import React from "react";
import { useDashboardStats } from "@/hooks/useDashboardStats";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader, StatCard } from "@/components/common/DashboardBits";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ClipboardList, Users, MapPin } from "lucide-react";

export default function ManagerOverview() {
  const { user } = useAuth();
  const stats = useDashboardStats();
  return (
    <div>
      <PageHeader title={`Welcome, ${user?.name || "Manager"}`} subtitle="Your territory overview" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        <StatCard testId="mgr-territory-size" label="Territory (pincodes)" value={stats?.territory_size ?? 0} tone="blue" />
        <StatCard testId="mgr-executives" label="Executives" value={stats?.executives ?? 0} tone="amber" />
        <StatCard testId="mgr-pending-approvals" label="Pending approvals" value={stats?.pending_approvals ?? 0} tone="red" />
        <StatCard testId="mgr-total-leads" label="Total leads" value={stats?.total_leads ?? 0} />
        <StatCard testId="mgr-visited" label="Visited" value={stats?.visited ?? 0} tone="green" />
      </div>
      <Card className="border border-slate-200 max-w-2xl">
        <CardContent className="p-6">
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500">Quick actions</div>
          <div className="mt-4 flex flex-wrap gap-3">
            <Link to="/manager/executives" className="inline-flex items-center gap-2 px-4 py-2 bg-slate-950 hover:bg-slate-800 text-white rounded-md text-sm">
              <Users className="h-4 w-4" /> My Executives {stats?.pending_approvals > 0 && <span className="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded">{stats.pending_approvals}</span>}
            </Link>
            <Link to="/manager/leads" className="inline-flex items-center gap-2 px-4 py-2 border border-slate-300 hover:bg-slate-50 rounded-md text-sm"><ClipboardList className="h-4 w-4" /> Leads</Link>
            <Link to="/manager/territory" className="inline-flex items-center gap-2 px-4 py-2 border border-slate-300 hover:bg-slate-50 rounded-md text-sm"><MapPin className="h-4 w-4" /> Territory</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
